module.exports = __webpack_public_path__ + "img/20210131_122033.12549aec.jpg";